import * as m from "mithril";
import { MessageProvider } from "../../../context/AppMessages";
import { DropOffOrderLineItemDTO, PickUpOrderLineItemDTO } from "../../../apiclient/ApiDtos";
import { getIntlStringValue } from "../../../helpers/StringHelpers";
import { formatMoney } from "../../../helpers/MoneyFormatter";
import CustomSvgIcon from "../../../components/CustomSvgIcon";

interface Attrs {
    messageProvider: MessageProvider,
    hideNumberOfPerson: boolean,
    wayPoint: PickUpOrderLineItemDTO | DropOffOrderLineItemDTO
}


export function WayPointItemComponent(): m.Component<Attrs> {
    return {
        view(vnode) {
            let { wayPoint, messageProvider } = vnode.attrs;
            let currLang = vnode.attrs.messageProvider.getCurrentLang();

            //let isFeeOnPoint = vnode.attrs.wayPoint.option.isFeeOnPoint == null || vnode.attrs.wayPoint.option.isFeeOnPoint == true;
            let isFeeOnPoint = (vnode.attrs.wayPoint.option.pricingMode ?? 'PER_SEAT') == 'PER_STOP';
            console.debug("Pricing Mode", vnode.attrs.wayPoint.option.pricingMode ?? 'PER_SEAT')
            return m(".card.mt-2",
                m(".card-body p-3 small",
                    m("div.d-flex", [
                        m("div.flex-grow-1", [
                            m("strong.text-secondary.mr-2", getIntlStringValue(wayPoint.option.name, currLang)),
                            vnode.attrs.hideNumberOfPerson ?
                                null
                                :
                                m("div.badge badge-light-blue font-weight-normal opacity-75 pt-1", {
                                    style: "font-size : 0.75rem;"
                                },
                                    wayPoint.numberOfSeats,
                                    " ",
                                    wayPoint.numberOfSeats > 1 ?
                                        vnode.attrs.messageProvider.get("way_point_selection.no_of_travellers_unit")
                                        :
                                        vnode.attrs.messageProvider.get("way_point_selection.no_of_traveller_unit")
                                )
                        ]),

                        m(".text-end.text-right font-weight-bold text-success", [
                            isFeeOnPoint ?
                                [
                                    m("div.text-right text-end", {
                                        style: "min-width: 80px;"
                                    },
                                        (vnode.attrs.wayPoint.option.unitFee.amount > 0) ?
                                            m("span.text-success", "MMK " + vnode.attrs.wayPoint.option.unitFee.amount) :
                                            m("span.text-success", "Free")
                                    )
                                ] :
                                m("div",
                                    wayPoint.numberOfSeats,
                                    " x ",
                                    formatMoney(wayPoint.option.unitFee)
                                ),

                        ])
                    ]),
                    wayPoint.option.mode == 'DOORSTEP' ?
                        m("div.text-break",
                            m("span.text-muted", vnode.attrs.messageProvider.get("way_point_selection.address") + " - "),
                            m("span.text-break text-secondary", wayPoint.address)
                        )
                        :
                        m("div.",
                            m("span.text-info font-weight-bold fw-bold",
                                vnode.attrs.messageProvider.get("common.gathering_point"),
                            ),
                            (wayPoint.option.description &&
                                (
                                    (vnode.attrs.messageProvider.getCurrentLang() == "en" && wayPoint.option.description.en != null && wayPoint.option.description.en.trim() != "") ||
                                    (vnode.attrs.messageProvider.getCurrentLang() == "my" && wayPoint.option.description.my != null && wayPoint.option.description.my.trim() != "")
                                )
                            ) &&
                            m("span.text-secondary ml-1",
                                " - ",
                                vnode.attrs.messageProvider.getCurrentLang() == "en" ?
                                    wayPoint.option.description.en
                                    :
                                    wayPoint.option.description.my
                            )
                        )
                )
            )
        }

    }
}